import Vue from "vue";
import Main from "./index.vue";
import { getDefaultProp } from "../../../utils";
import merge from "lodash.merge";
/**
 * 使用extend方法构建constructor动态创建组件
 */
const NotifyConstructor = Vue.extend(Main);

/**
 * 维护notify队列
 */
let instance;
const instances = [];
let seed = 1;

const getDefaultOptions = () => {
  return {
    duration: getDefaultProp(
      Vue.prototype.$SJ_COMPONENTS_CONFIG?.Notify?.duration,
      4500
    ),
    showClose: getDefaultProp(
      Vue.prototype.$SJ_COMPONENTS_CONFIG?.Notify?.showClose,
      false
    )
  };
};

const Notify = (options = {}) => {
  const id = `notification_${seed++}`;
  const userOnClose = options.onClose;

  /**
   * 为notify组件注入onClose方法
   */
  options.onClose = function() {
    Notify.close(id, userOnClose);
  };

  instance = new NotifyConstructor({
    data: merge(getDefaultOptions(), options)
  });

  instance.id = id;
  instance.$mount();
  document.body.appendChild(instance.$el);

  instance.visibleData = true;
  instance.dom = instance.$el;

  /**
   * 创建notify时根据当前notify数量计算偏移量
   */
  let verticalOffset = options.offset || 0;

  instances.forEach(item => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;
  instances.push(instance);

  return instance;
};

/**
 * 关闭notify时将对应的notify出队
 */
Notify.close = (id, userOnClose) => {
  let index = -1;
  const len = instances.length;
  const instance = instances.filter((instance, i) => {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === "function") {
    userOnClose(instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  /**
   * notify关闭时重新计算偏移量
   */
  // const position = instance.position;
  const removedHeight = instance.dom.offsetHeight;
  for (let i = index; i < len - 1; i++) {
    instances[i].dom.style.top = `${parseInt(instances[i].dom.style.top, 10) -
      removedHeight -
      16}px`;
  }
};

export default Notify;
